/** Round white back button with pink arrow (same as social-collage scan screen). */
const ScanBack = () => (
  <svg width="108" height="108" viewBox="0 0 108 108" fill="none" aria-hidden="true">
    <g filter="url(#scanBackShadow)">
      <rect x="4" width="100" height="100" rx="50" fill="white" shapeRendering="crispEdges" />
      <path
        d="M30.5 49.5L28.4671 47.4671L26.4341 49.5L28.4671 51.5329L30.5 49.5ZM73.625 52.375C75.2128 52.375 76.5 51.0878 76.5 49.5C76.5 47.9122 75.2128 46.625 73.625 46.625V49.5V52.375ZM47.75 32.25L45.7171 30.2171L28.4671 47.4671L30.5 49.5L32.5329 51.5329L49.7829 34.2829L47.75 32.25ZM30.5 49.5L28.4671 51.5329L45.7171 68.7829L47.75 66.75L49.7829 64.7171L32.5329 47.4671L30.5 49.5ZM30.5 49.5V52.375H73.625V49.5V46.625H30.5V49.5Z"
        fill="#000"
      />
    </g>
    <defs>
      <filter id="scanBackShadow" x="0" y="0" width="108" height="108" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default ScanBack;
